import { Route } from 'react-router';
import { importOrReload } from '@/utils/route.utils';

export const onboardingRoutes = (
  <Route
    path="onboarding"
    lazy={importOrReload(() => import('@/pages/onboarding/layout'))}
  >
    <Route
      index
      path="select-appointment?"
      lazy={importOrReload(() => import('@/pages/onboarding/select-time/page'))}
    />
    <Route
      path="privacy-protection"
      lazy={importOrReload(
        () => import('@/pages/onboarding/privacy-protection-message/page')
      )}
    />
    <Route
      path="all-secure"
      lazy={importOrReload(
        () => import('@/pages/onboarding/all-secure-page/page')
      )}
    />
    <Route
      path="personal-information"
      lazy={importOrReload(
        () => import('@/pages/onboarding/personal-info/page')
      )}
    />
    <Route
      path="verification"
      lazy={importOrReload(
        () => import('@/pages/onboarding/verification/page')
      )}
    />
    <Route
      path="forms"
      lazy={importOrReload(
        () => import('@/pages/onboarding/forms-to-complete/page')
      )}
    />
    <Route
      path="all-set"
      lazy={importOrReload(() => import('@/pages/onboarding/all-set/page'))}
    />
    <Route
      path="email-mismatch"
      lazy={importOrReload(
        () => import('@/pages/onboarding/email-mismatch/page')
      )}
    />
    <Route path="*" lazy={importOrReload(() => import('@/pages/not-found'))} />
  </Route>
);
